import { OpAdminBannersAndOffersService } from '../../../../common/services/op-admin-banners-and-offers.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dropdown-dialog',
  templateUrl: './dropdown-dialog.component.html',
  styleUrls: ['./dropdown-dialog.component.css']
})
export class DropdownDialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  codeList: any = [];
  selectValue: any;
  constructor(private activeModal: NgbActiveModal, private bannersoffersService:OpAdminBannersAndOffersService) { }

  ngOnInit() {
    this.bannersoffersService.getCodeList('Banner').subscribe((res: any) => {
      this.codeList = res;
      this.codeList = this.codeList.data;
    });
  }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(this.selectValue);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  getValue(value){
    this.selectValue = value;
  }

}
